import mitt from "mitt";

export type EventUnsavedChangesParams = {
  onConfirm: () => void | Promise<void>;
};

export type EmitterEvents = {
  bodyClick: Event;
  selectContainerOpen: undefined;
  showUnsavedChanges: EventUnsavedChangesParams;
};

const emitter = mitt<EmitterEvents>();

export default emitter;
